<template>
  <div class="card-primary">
    <line-chart
      v-if="loaded"
      :countGraph="countGraph"
      :waktuGraph="waktuGraph"
      :width="400"
      :height="400"
    ></line-chart>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import LineChart from "@/components/Home/LineChart.vue";

export default {
  name: "Chart",
  components: {
    LineChart,
  },
  data() {
    return {
      countGraph: [],
      waktuGraph: [],
      loaded: false,
    };
  },
  methods: {
    drawChart(data) {
      if (data != null) {
        var arrayCount = [];
        var arrayWaktu = [];

        data.map((a) => {
          var count = a.count;
          var waktu = moment(a.date).format("DD-MM HH:mm");
          arrayCount.push(count);
          arrayWaktu.push(waktu);
        });

        this.countGraph = arrayCount;
        this.waktuGraph = arrayWaktu;
        // console.log(this.countGraph)
        this.loaded = true;
      }
    },
  },
  mounted() {
    var token = localStorage.token;
    var startdate = moment();
    startdate = startdate.subtract(3, "days");
    startdate = startdate.format("YYYY-MM-DD");
    var enddate = moment().format("YYYY-MM-DD");
    axios
      .get(
         `issues/graph?sdate=${startdate}&edate=${enddate}`
      )
      .then(
        (response) =>
          // handle success
          this.drawChart(response.data)
        // console.log(response.data)
      )
      .catch((error) =>
        // handle error
        console.log(error)
      );
  },
};
</script>

<style scoped>
/* .card-primary{
  height: 870px !important;
} */
</style>


// WEBPACK FOOTER //
// src/components/Home/ChartProject.vue